/*******************************************************
 * Copyright (C) 2010-Present Avant Assessment
 * All Rights Reserved
 *******************************************************/
import {AxiosResponse} from "axios"
import {ApiErrorResponse} from "../types/types"
import ApiService from "./ApiService"

export default class HelperServiceApi {

    static logout() {
        const url: string = `${ApiService.API_URL}logout`
        ApiService.get(url).then(
            (_: AxiosResponse) => {
                //NOOP
            },
            (_: ApiErrorResponse) => {
                //NOOP
            }
        )
    }

}
